import React from 'react';

const Welcome = () => {
    return (
        <div className='py-2'>
            <h1 className="text-center lg:text-3xl">Welcome Everyone just click navbar see your's details</h1>
        </div>
    );
};

export default Welcome;